import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { getEntities } from 'dash-front/selectors';
import { CAMPAIGN_FORM_ID, CAMPAIGN_FORM_KEYS, STORE_KEYS } from '../../constants';

const valueSelector = formValueSelector(CAMPAIGN_FORM_ID);

const mapStateToProps = state => {
    return {
        targets: getEntities(state)[STORE_KEYS.SMLINKS],
        selectedTargets: valueSelector(state, CAMPAIGN_FORM_KEYS.TARGETS.ARRAY),
    };
};

export default connect(mapStateToProps);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/enhancers/withTargetsFormProps.js
 **/